'use client'

/**
 * Desk control wrappers — Ant Design only, ThemeSystem tokens, small by default.
 * Import these instead of raw antd Button/Select/Switch/Segmented/Input/Tabs
 * so every bay speaks the same chassis.
 */

import React, { forwardRef } from 'react'
import {
  Button,
  Input,
  InputNumber,
  Segmented,
  Select,
  Switch,
  Tabs,
} from 'antd'
import type {
  ButtonProps,
  InputNumberProps,
  InputProps,
  InputRef,
  SegmentedProps,
  SelectProps,
  SwitchProps,
} from 'antd'
import type { TabsProps } from 'antd'
import { DESK_CONTROL_SIZE } from './DeskChassis'

export const DeskButton = forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonProps>(
  function DeskButton(props, ref) {
    return <Button size={DESK_CONTROL_SIZE} {...props} ref={ref} />
  }
)

export const DeskInput = forwardRef<InputRef, InputProps>(function DeskInput(props, ref) {
  return <Input size={DESK_CONTROL_SIZE} {...props} ref={ref} />
})

export function DeskInputNumber(props: InputNumberProps) {
  return <InputNumber size={DESK_CONTROL_SIZE} {...props} />
}

export function DeskSelect<ValueType = string>(props: SelectProps<ValueType>) {
  return <Select<ValueType> size={DESK_CONTROL_SIZE} {...props} />
}

export function DeskSwitch(props: SwitchProps) {
  return <Switch size="small" {...props} />
}

export function DeskSegmented<T extends string | number>(props: SegmentedProps<T>) {
  return <Segmented<T> size={DESK_CONTROL_SIZE} {...props} />
}

export function DeskTabs(props: TabsProps) {
  return <Tabs size={DESK_CONTROL_SIZE} {...props} />
}
